// extracted by mini-css-extract-plugin
export default {"settingsModal":"SettingsModal_settingsModal__Ezw3P","faToggle":"SettingsModal_faToggle__BmXS+"};